import React from 'react';
import SubscriptionPlans from '../../../../shared/SubscriptionCheckout/SubscriptionPlans/SubscriptionPlans';
import useGetAgentCheckoutLinks from '../../../../Hooks/Agent/Getters/useGetAgentCheckoutLinks/useGetAgentCheckoutLinks';
import tiers from './subscriptionTiersData';

/** @returns {JSX.Element} */
export default function Checkout() {
	const checkoutLinks = useGetAgentCheckoutLinks();

	return (
		<section className="pt-6">
			<SubscriptionPlans
				checkoutRole="agent"
				isGettingData={checkoutLinks.isGettingData}
				paymentLinks={checkoutLinks.data}
				tiers={tiers}
			/>
		</section>
	);
}
